
import { Modal, ModalProps } from "antd"
import { useRef } from "react"
import { createRoot } from "react-dom/client"
import { Editor } from "@monaco-editor/react"
import { PropertySetModule } from "@/services/admin/property-set/modal"
import { updateSetJson, OrganizationPropertySetService } from "@/services/admin/property-set"

interface EditJsonModalProps extends ModalProps {
  propertySet: PropertySetModule.Modal
  onSuccess: () => void
  onCancel?: () => void
  orgId?: number
}

export function EditJsonModal(props: EditJsonModalProps) {
  const {propertySet, onSuccess, onCancel, orgId} = props

  const editorRef = useRef(null);

  function handleEditorDidMount(editor) {
    editorRef.current = editor;
    editor.getAction('editor.action.formatDocument').run();
  }

  async function saveJson() {
    const editor: any = editorRef.current
    const value = editor.getValue()
    const jsonStr = JSON.stringify(JSON.parse(value))
    if (orgId) {
      await OrganizationPropertySetService.updateSetJson(orgId, {content: jsonStr}, {setId: propertySet.id})
    } else {
      await updateSetJson({content: jsonStr}, {setId: propertySet.id})
    }
    onSuccess()
  }

  return <Modal
    {...props}
    width={'90%'}
    maskClosable={false}
    okText="Save"
    open
    onOk={saveJson}
    onCancel={onCancel}
  >
    <div>Edit JSON</div>
    <Editor
      height='60vh'
      defaultLanguage='json'
      defaultValue={propertySet.json}
      onMount={handleEditorDidMount}
    />
  </Modal>
}

EditJsonModal.show = (props: EditJsonModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<EditJsonModal
    {...props}
    onCancel={() => {
      props.onCancel?.()
      root.unmount()
    }}
    onSuccess={() => {
      props.onSuccess()
      root.unmount()
    }}
  />);
}